<script setup lang="ts">
    defineOptions({ inheritAttrs: false });

    type Props = {
        disabled?: boolean;
        required?: boolean;
        maxlength?: number;
        type?: string;
        placeholder?: string;
        textAreaLines?: number;
        messageType?: string;
    };

    const props = withDefaults(defineProps<Props>(), {
        disabled: false,
        required: false,
        maxlength: undefined,
        type: 'text',
        placeholder: undefined,
        textAreaLines: 0,
        messageType: undefined
    });

    const model = defineModel<string | null>({ default: null });
</script>

<template>
    <textarea
        v-if="props.textAreaLines > 0"
        v-model="model"
        :disabled="disabled"
        :class="messageType"
        class="textarea"
        :rows="props.textAreaLines" />
    <b-input
        v-else
        v-model="model"
        :disabled="disabled"
        :required="required"
        :maxlength="maxlength"
        :type="type"
        :placeholder="placeholder" />
</template>
